import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'


@Injectable({
  providedIn: 'root',
})
export class ReminderService {
  private baseUrl = environment.baseUrl
  private resource: string = 'lembrete'

  constructor(private httpClient: HttpClient) {}

  public createReminder(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create-completo`,
      model,
    )
  }

  public updateReminder(
    model: any,
    // model: EditPurchasesQuoteRequestModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteReminder(
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${id}`,
    )
  }

  public listPagedReminder(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchReminder(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listReminder(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }  public listWeekDays(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list`,
    )
  }

  public listReminderByIdPaciente(
    id: number,
    params?: any
  ): Observable<ResponseRequestModel> {
    // Constrói os query params dinamicamente
    let queryParams = '';

    if (params && params.status !== null && params.status !== undefined) {
      queryParams = `ativo=${params.status}`;
    }

    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paciente/${id}${queryParams ? '?' + queryParams : ''}`
    )
  }

  public searchPagedPurchasesQuoteRequest(
    page: number,
    rows: number = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
